import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ModalService } from '@common/services/modal.service';
import { DataService, InvoiceRecord, PartnerRecord, DateRange } from '@core/services/data.service';
import { PartnersService } from '@core/services/partners.service';
import { SynchronizationService } from '@core/services/synchronization.service';
import { TagsService } from '@core/services/tags.service';
import { ViewerComponent } from '@routes/invoices/viewer/viewer.component';
import { PartnersComponent } from '@routes/configs/partners/partners.component';

@Component({
  selector: 'invoice',
  templateUrl: './ui.component.html',
  styleUrls: ['./ui.component.scss']
})
export class UiComponent implements OnInit {

  private _loading: boolean = false;

  public get loading(): boolean {
    return this._loading;
  }

  @Input()
  public filters: { customer?: string, vendor?: string, sku?: string, color?: string, importTag?: string, exportTag?: string, exportAfter?: { name: string, range: DateRange } };


  @Input()
  public displays: { stamp?: boolean, partner?: boolean, id?: boolean } = { id: false, stamp: false, partner: false }

  private _invoice: InvoiceRecord;

  @Input()
  public set invoice(value: InvoiceRecord) {

    this._invoice = value;

    if (value && value.ID > 0) {
      this._id = value.ID;
      this._tag = value.Tag;
      this._stamp = value.Stamp;
    }
  }

  public get invoice(): InvoiceRecord {
    return this._invoice;
  } 

  private _stamp: number | Date;

  @Input()
  public set stamp(value: number | Date) {
  this._stamp = value;
  }

  public get stamp(): number | Date {
    if (this._stamp) return this._stamp;

    if (this._tag) {
      let tag = this.tags.get(this._tag);
      return tag ? tag.Stamp : undefined;
    }

    if (this._id) {
      let tag = this.tags.get(this._id);
      return tag ? tag.Stamp : undefined;
    }

    return undefined;
  }

  private _tag: string;

  @Input()
  public set tag(value: string) {    
    this._tag = value;
  }

  public get tag(): string {

    if (this._tag) return this._tag;

    if (this._id) {
      let tag = this.tags.get(this._id);
      return tag ? tag.Tag : undefined;
    }

    return undefined;
  }

  private _id: number;

  @Input()
  public set id(value: number) {
    this._id = value;
  }

  public get id(): number {

    if (this._id) return this._id;

    if (this._tag) {
      let tag = this.tags.get(this._tag);
      return tag ? tag.InvoiceID : undefined;
    }

    return undefined;
  }

  @Input()
  public openable: boolean = true;

  public get partner(): PartnerRecord {

    let id = this.id;

    if (id) {

      let tag = this.tags.get(id);
      if (!tag) return undefined;

      let partner = this.partners.get(tag.PartnerID);
      return partner ? partner : undefined;
    }

    return undefined;
  }

  @Output()
  public unconfirmed = new EventEmitter<InvoiceRecord>();

  constructor(private partners: PartnersService, private sync: SynchronizationService, private tags: TagsService, private ds: DataService, private modal: ModalService) {
  }

  ngOnInit(): void {
  }

  public open() {

    if (!this.openable) return;

    if (this.id && this.id > 0) {

      if (!this.invoice || this.invoice.Details.length == 0) {

        this._loading = true;

        this.sync.with(UiComponent).commit(done => this.ds.invoices('get', { ID: this.id }).subscribe(invoices => {          

          if (invoices && invoices.length == 1) {
            this._invoice = invoices[0];
          }

          done();
        }));
      }

      this.sync.when(UiComponent, PartnersService, TagsService).commit(() => {

        this._loading = false;

        if (this.invoice && this.invoice.Details.length > 0)
          this.modal.show(ViewerComponent, { state: { invoice: this.invoice, filters: this.filters } }).content.unconfirmed.subscribe(invoice => this.unconfirmed.emit(invoice));
      });
    }
  }
}
